
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13115',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13115",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.490",
  "data-fetching-client": "static-1.9903",
  "foundations-components": "static-1.8382",
  "foundations-components-legacy": "static-1.1407",
  "foundations-theming": "static-1.4701",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.86",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8273",
  "hub-http-shared-msw-handlers": "static-1.10524",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11730",
  "I18n": "static-7.1661",
  "jasmine-runner": "static-1.6695",
  "marketplace-discovery-studio-lib": "static-1.547",
  "marketplace-storefront-base": "static-1.13178",
  "quartz": "static-1.7365",
  "react-dlb": "static-1.84",
  "react-rhumb": "static-1.16954",
  "reactive-variable-buffer-atom": "static-1.3102",
  "reporting-testing-lib": "static-1.10509",
  "reselect": "static-3.9",
  "settings-ui-lib": "static-1.12766",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7555",
  "ui-addon-i18n": "static-1.11392",
  "ui-addon-react-router-dom": "static-1.9779",
  "unified-auth": "static-1.798",
  "unified-auth-core-lib": "static-1.1080",
  "usage-tracker": "static-1.7602",
  "usage-tracker-core": "static-1.7452",
  "customer-data-property-utils": "static-1.8345",
  "hub-http": "static-1.6458",
  "integrations-lib": "static-1.16923",
  "marketplace-ui-common": "static-1.20596",
  "marketplace-ui-install": "static-1.582",
  "property-management-iframe": "static-1.13985",
  "quartz-config": "static-1.1143",
  "quartz-core": "static-1.6584",
  "quartz-routing": "static-1.795",
  "quick-fetch": "static-1.4092",
  "react": "static-7.190",
  "rpc-client-utils": "static-1.4909",
  "ts-schema": "static-1.4254",
  "ui-universal-auth": "static-1.9284",
  "UIComponents": "static-3.8676",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3575",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3642",
  "quartz-webpack": "static-1.3589",
  "bend-plugin-quartz-routing": "static-1.443",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4651",
  "floating-ui": "static-1.61",
  "foundations-assets": "static-1.5122",
  "foundations-theming-specialty": "static-1.2417",
  "framer-motion": "static-1.76",
  "hs-story-utils": "static-1.9673",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.60",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5515",
  "react-virtualized": "static-2.104",
  "StyleGuideUI": "static-3.495",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2466",
  "ui-fonts": "static-1.992",
  "ui-images": "static-2.1229",
  "bend-plugin-foundations-theming": "static-1.3184",
  "foundations-theming-base": "static-1.3686",
  "stylex": "static-1.38",
  "HeadJS": "static-2.789",
  "hs-test-utils-bend-plugin": "static-1.3384",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4564",
  "ui-addon-video-player": "static-1.8951",
  "ai-components-ui-library": "static-1.9579",
  "ai-rendering-library": "static-1.10999",
  "chirp-fetch": "static-1.2137",
  "connections-embed-lib": "static-1.1429",
  "copilot-toolkit": "static-1.11740",
  "feedback-loader": "static-1.29733",
  "laboratory-lib": "static-3.7398",
  "marketplace-embed": "static-1.22813",
  "marketplace-ui-details": "static-1.10491",
  "marketplace-ui-reviews": "static-1.20551",
  "marketplace-ui-tracking": "static-1.14766",
  "sanitize-text": "static-1.8396",
  "usage-tracker-multi": "static-1.6016",
  "usage-tracker-session-replay": "static-1.5288",
  "wootric-nps": "static-1.7160",
  "quartz-head": "static-1.1030",
  "web-vitals": "static-1.11",
  "apollo-link-hub-http": "static-2.4903",
  "immer": "static-1.94",
  "immerable": "static-1.4398",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2651",
  "reporting-data": "static-1.68576",
  "cssUtils": "static-1.869",
  "flux-actions": "static-1.360",
  "HubStyle": "static-2.12037",
  "PatternValidationJS": "static-1.3143",
  "react-colorpicker": "static-2.10453",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10612",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7592",
  "icons": "static-2.674",
  "marketplace-ui-apps-core": "static-1.19128",
  "storybook-react": "static-1.37",
  "trellis-story-utils": "static-1.4756",
  "foundations-components-test-utils": "static-1.5865",
  "quartz-i18n": "static-1.1040",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.349",
  "ads-unified-auth-lib": "static-1.1032",
  "google-sheets-integration-lib": "static-1.926",
  "microsoft-drive-auth-lib": "static-1.16",
  "surveymonkey-integration-lib": "static-1.370",
  "slack-ui-library": "static-1.10643",
  "fsm": "static-1.3985",
  "customer-data-objects": "static-1.7933",
  "property-translator": "static-1.5640",
  "hs-locale-management": "static-1.255",
  "frontend-preferences-client": "static-1.8174",
  "hs-promise-utils": "static-1.5842",
  "hubspot-apollo-client": "static-1.5124",
  "integrations-error-boundary-lib": "static-1.14338",
  "integrations-tracking-lib": "static-1.5854",
  "native-integrations-shared-strings": "static-1.8023",
  "sanitize": "static-1.4722",
  "superstore": "static-1.5004",
  "ui-shepherd-react": "static-3.10509",
  "ai-settings-ui-library": "static-1.8254",
  "hub-http-janus": "static-1.867",
  "hubspotter-http": "static-1.4824",
  "immutable-less": "static-1.4897",
  "marketplace-ui-client-types": "static-1.18003",
  "nav-meta": "static-1.30348",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18319",
  "ui-product-approvals-common": "static-1.880",
  "ai-studio-lib": "static-1.12354",
  "hubspot-prosemirror": "static-1.18867",
  "integrations-reconnect-lib": "static-1.402",
  "ui-addon-iframeable": "static-1.9323",
  "ui-addon-integrations-directory-panel": "static-2.8272",
  "ui-product-approvals": "static-1.28985",
  "ui-tool-access": "static-1.10399",
  "inbound-db-properties-service-client": "static-1.4018",
  "property-management-common": "static-1.6273",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.565",
  "module-federation": "static-1.30",
  "quartz-auth": "static-1.1040",
  "quartz-test": "static-1.1040",
  "quartz-tracking": "static-1.744",
  "trellis-components": "static-1.2485",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.319",
  "bender-build-tools": "static-1.3358",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22627",
  "ContentUtils": "static-1.69052",
  "customer-data-objects-ui-components": "static-1.13277",
  "sassPrefix": "static-1.161",
  "avatar-components": "static-1.2743",
  "breeze-engine-core": "static-1.844",
  "breeze-onboarding-components": "static-1.608",
  "customer-data-filters-ui": "static-1.40751",
  "customer-data-reference-ui-components": "static-1.13426",
  "embedded-academy-lib": "static-1.15341",
  "ExportDialog": "static-6.10626",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41907",
  "reporting-snowflake": "static-1.57194",
  "reporting-ui-components": "static-2.65847",
  "reporting-visualizations": "static-1.60652",
  "trial-components-library": "static-1.14020",
  "trellis-theming": "static-1.1207",
  "ui-addon-teams": "static-1.21853",
  "upgrade-components-lib": "static-1.454",
  "magpie-lib": "static-1.5718",
  "navigation-components": "static-1.18711",
  "breeze-engine-lib": "static-1.1566",
  "magpie-types": "static-1.5178",
  "simple-logging-lib": "static-1.3295",
  "fail-safe": "static-1.200",
  "app-governance-lib": "static-1.2291",
  "developer-experience-shared-components": "static-1.10746",
  "purchase-motions-components": "static-1.6281",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.10035",
  "usage-tracker-anonymous": "static-1.6019",
  "usage-tracker-public": "static-1.7413",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3948",
  "reference-resolvers": "static-1.8429",
  "ui-extensibility-client-types": "static-1.4166",
  "hubspot-apollo-cache": "static-1.583",
  "universal-page-editor-lib": "static-1.3256",
  "final-form": "static-1.75",
  "redux-toolkit": "static-1.75",
  "simple-data-table": "static-1.3434",
  "atom": "static-1.5329",
  "merchandise-lib": "static-1.273",
  "salesImages": "static-1.530",
  "codemirror": "static-5.99",
  "react-codemirror": "static-1.10886",
  "ui-addon-draggable": "static-3.5002",
  "content-assistance-lib": "static-1.8130",
  "content-media-capture": "static-1.5305",
  "customer-data-ui-utilities": "static-1.10072",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24360",
  "growth-payments-core": "static-1.26069",
  "knowledge-content-types": "static-1.8618",
  "payment-link-components": "static-1.24075",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20234",
  "ui-addon-emoji-picker": "static-1.10132",
  "ui-business-units-lib": "static-1.9328",
  "video-components-external": "static-1.12053",
  "video-data-lib": "static-1.35711",
  "navigation-messaging": "static-1.8038",
  "collaboration-sidebar": "static-1.58601",
  "react-dnd-compat": "static-1.4862",
  "batch-promise": "static-1.1791",
  "crm-component-utils": "static-1.39724",
  "crm-properties-common-lib": "static-1.6136",
  "customer-data-properties": "static-1.52423",
  "external-options-client-types": "static-1.4301",
  "framework-data-schema-resolvers": "static-1.7140",
  "property-value-citations": "static-1.3037",
  "reference-resolvers-lite": "static-1.8346",
  "hubspotter-http-shared-msw-handlers": "static-1.10522",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "cms-field-types": "static-1.5061",
  "content-icons-ui": "static-1.2310",
  "breeze-artifacts-sdk": "static-1.183",
  "onboarding-journeys-lib": "static-1.769",
  "pulse": "static-1.873",
  "conversations-skeleton-state": "static-1.7495",
  "crm-message-bus": "static-1.43636",
  "customer-data-filters-ui-msw-helpers": "static-1.23186",
  "events-data-lib": "static-1.489",
  "FormUrlGenerator": "static-2.4972",
  "framework-builder-read-service-client": "static-1.4181",
  "hs-resources": "static-1.436",
  "multi-account-reference-resolvers": "static-1.1243",
  "onboarding-scopes": "static-1.6704",
  "onboarding-tours": "static-1.17037",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14363",
  "academy-common-lib": "static-1.14801",
  "dashboard-lib": "static-1.82628",
  "getting-started-shared-tasks": "static-1.19109",
  "hubspot-prosemirror-plugins": "static-1.18859",
  "share-with-third-party-component-lib": "static-1.8950",
  "ui-asset-management-lib": "static-1.11342",
  "user-context": "static-1.5358",
  "reporting-plugins": "static-1.10671",
  "reporting-reports": "static-1.68254",
  "hubs-service-types": "static-1.1503",
  "purchase-motions-api": "static-1.6284",
  "signup-constants": "static-1.19488",
  "idb-keyval": "static-1.48",
  "reactive-lib": "static-1.967",
  "nest": "static-1.483",
  "breeze-engine-chat-components": "static-1.544",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.151",
  "framework-listing-lib": "static-2.29372",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31316",
  "apps-service-types": "static-1.3995",
  "oauth-service-types": "static-1.4501",
  "signup-ui-url-generator": "static-2.8306",
  "onboarding-tours-client": "static-1.5251",
  "one-click-checkout": "static-1.305",
  "platform-infra-nav-components": "static-1.7847",
  "subscription-experience-data-types": "static-1.15196",
  "crm-record-cards-service-types": "static-1.3756",
  "location-customization-utils-lib": "static-1.9986",
  "redux-thunk": "static-2.77",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "react-flip-move": "static-1.75",
  "ui-coaching-tips": "static-1.29210",
  "content-media-composition-data-lib": "static-1.13109",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4670",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.610",
  "ui-addon-opt": "static-4.8609",
  "commerce-tours-lib": "static-1.6533",
  "growth-onboarding-reliability": "static-1.5326",
  "sales-checkout-service-client": "static-1.3779",
  "data-token-picker": "static-1.16813",
  "FileManagerLib": "static-1.40000",
  "content-media-compositions": "static-2.17116",
  "media-bridge-lib": "static-1.19334",
  "chatspot-widget-iframe": "static-1.22618",
  "collaboration-sidebar-common": "static-1.3398",
  "marketing-platform-lib": "static-1.7115",
  "card-properties-lib": "static-1.44900",
  "commerce-subscription-lib": "static-1.37677",
  "crm-actions": "static-1.6598",
  "crm-cards-sdk": "static-1.44375",
  "customer-data-properties-shared-msw-handlers": "static-1.9851",
  "customer-data-tracking": "static-1.7128",
  "calling-global-api": "static-1.65366",
  "calling-internal-common": "static-1.31562",
  "calling-lifecycle-internal": "static-1.66748",
  "calling-lifecycle-messages": "static-1.59042",
  "commerce-products-lib": "static-1.10403",
  "conditional-properties-service-client": "static-1.3975",
  "crm-index-visualization-core": "static-1.4473",
  "crm-links": "static-1.6569",
  "crm-pipelines-api-client-types": "static-1.4308",
  "formula-editor": "static-1.14673",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4386",
  "meetings-icalendar-utils-lib": "static-1.882",
  "multi-currency-client-types": "static-1.3868",
  "object-builder-ui-client": "static-1.49528",
  "pipeline-validation-client-types": "static-1.4143",
  "smart-property-lib": "static-1.8164",
  "tiered-pricing": "static-1.1856",
  "topics-actions-lib": "static-1.407",
  "ui-addon-form-validation": "static-1.11232",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.259",
  "framework-data-schema-quick-fetch": "static-1.7045",
  "bend-plugin-pulse": "static-1.376",
  "event-emitter": "static-1.1200",
  "fast-json-patch": "static-1.67",
  "restore-request-side-panel-lib": "static-1.1550",
  "growth-data-modal": "static-1.5816",
  "growth-onboarding-confetti": "static-1.3307",
  "growth-onboarding-next-action-utils": "static-1.2592",
  "onboarding-tours-utils": "static-1.1103",
  "ui-shepherd-tracker": "static-1.7890",
  "academy-service-client": "static-1.3936",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39859",
  "SafeStorage": "static-1.4650",
  "video-embed": "static-1.36545",
  "redux-actions": "static-3.68",
  "EmailSignatureEditor": "static-1.24912",
  "viral-links-lib": "static-1.7321",
  "nested-table": "static-1.480",
  "timezone-utils": "static-2.5494",
  "getting-started-shared-tasks-store": "static-1.18227",
  "campaign-roi-lib": "static-1.9990",
  "ui-addon-calendars": "static-2.5572",
  "customer-data-views-management": "static-1.25929",
  "framework-data-table": "static-2.12443",
  "nudge-client-utils": "static-1.3065",
  "nudge-custom-ui-functions": "static-1.1417",
  "switchboard-lib": "static-1.461",
  "access-check-ui-lib": "static-1.1481",
  "app-users-service-client": "static-1.5864",
  "app-users-service-types": "static-1.5272",
  "mini-checkout-client": "static-1.27400",
  "onboarding-utils": "static-1.5608",
  "permissions-shared-i18n-strings-fe": "static-1.2118",
  "ui-coaching-tips-shared-config": "static-1.29195",
  "checkout-sdk": "static-3.24243",
  "payment-method-components": "static-1.7095",
  "touchless-buying-components": "static-1.6111",
  "upgrade-catalog-service-types": "static-1.3731",
  "edison-service-client-types": "static-1.637",
  "growth-onboarding-feedback-components": "static-1.6829",
  "audio-components": "static-1.6272",
  "FileManagerImages": "static-1.37511",
  "video-components": "static-1.14055",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92724",
  "customer-data-sidebar": "static-2.46641",
  "enrichment-properties-lib": "static-1.17784",
  "ui-addon-draggable-compat": "static-2.4508",
  "universal-record-utils-lib": "static-1.1735",
  "commerce-billing-lib": "static-1.19986",
  "commerce-shared-components-lib": "static-1.19126",
  "commerce-tools-ui-lib": "static-1.10955",
  "crm-fe-perf": "static-1.23146",
  "calling-error-reporting": "static-1.31569",
  "shared-worker-versioning": "static-1.11287",
  "calling-usage-tracker": "static-1.6785",
  "voice-sms-access-library": "static-1.1905",
  "commerce-permissions": "static-1.1023",
  "products-iframe-lib": "static-1.8494",
  "products-ui-components-shared-msw-handlers": "static-1.10906",
  "crm-index-associations-lib": "static-1.6688",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10607",
  "sales-views-client-types": "static-1.4504",
  "bark-lib": "static-1.16752",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.573",
  "policy-lib": "static-1.7040",
  "react-tinymce": "static-1.55872",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10670",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54998",
  "tinymce-plugins": "static-1.58112",
  "tinymce-themes": "static-1.56968",
  "onboarding-data-sync-lib": "static-1.2397",
  "growth-onboarding-next-action-components": "static-1.2620",
  "user-context-client": "static-1.4754",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4779",
  "outpost": "static-1.4408",
  "draft-convert": "static-2.77",
  "draft-extend": "static-3.80",
  "draft-js": "static-5.82",
  "draft-plugins": "static-2.22082",
  "sales-email-signature-service-client": "static-1.4091",
  "ts-utils-lib": "static-1.421",
  "crm-export-dialog": "static-1.6531",
  "crm-view-components": "static-1.997",
  "react-beautiful-dnd": "static-1.67",
  "customer-data-associations": "static-1.7577",
  "nudge-custom-function-registry": "static-1.2822",
  "nudge-renderer-utils": "static-1.3141",
  "whisper-core-api": "static-1.7224",
  "InboxConnectUtils": "static-4.15455",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46744",
  "hub-http-rxjs": "static-1.832",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4238",
  "company-details-components": "static-1.6446",
  "react-performance-metrics-lib": "static-1.801",
  "pricing-pages-ui-components": "static-1.15493",
  "quote-checkout-service-types": "static-1.3701",
  "social-insights-client-types": "static-1.22685",
  "crm_universal": "static-1.22424",
  "customer-data-email": "static-1.18449",
  "card-payment-highlight-lib": "static-1.37869",
  "card-subscription-highlight-lib": "static-1.40100",
  "commerce-contract-lib": "static-1.13140",
  "invoices-highlight-card-lib": "static-1.55541",
  "orders-highlight-card-lib": "static-1.22089",
  "products-highlight-card-lib": "static-1.18686",
  "quotes-highlight-card-lib": "static-1.72737",
  "crm-source-interpretation-lib": "static-1.5579",
  "data-agent-utils": "static-1.179",
  "crm-object-search-query-utilities": "static-1.10111",
  "utility-belt": "static-1.2777",
  "payments-enrollment-embed-lib": "static-1.23697",
  "stripe-embedded-components": "static-1.7923",
  "customer-data-rte": "static-1.33556",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6190",
  "payments-post-enroll-local-storage-lib": "static-1.5353",
  "qrcode-generator": "static-1.73",
  "quotes-client-types": "static-1.38827",
  "calling-orchestration-schema": "static-1.36682",
  "react-reducer-toolkit": "static-1.16262",
  "hub-http-contrib": "static-1.3285",
  "interframe": "static-3.5003",
  "tinymce-data": "static-1.41083",
  "ui-addon-sales-email": "static-1.5460",
  "layout-dnd-components": "static-1.12890",
  "layout-dnd-utils": "static-1.11865",
  "ui-brand-identity-lib": "static-1.16216",
  "NamespacedHubStyle": "static-2.9223",
  "meetings-connect-utils-lib": "static-1.7854",
  "access-control-lib": "static-1.10683",
  "EmailComponents": "static-1.55449",
  "EmailData": "static-1.54127",
  "redux-less": "static-2.9726",
  "company-details-service-types": "static-1.4186",
  "segments-query-core": "static-1.1670",
  "pricing-pages-api": "static-1.15358",
  "sequences-lib": "static-1.8463",
  "ui-gdpr-components": "static-1.10600",
  "products-ui-components": "static-1.40921",
  "accounting-integrations-ui-components": "static-1.7464",
  "invoices-ui-lib": "static-1.55557",
  "commerce-products-api": "static-1.2636",
  "invoices-iframe-lib": "static-1.57615",
  "quotes-modal-lib": "static-1.103415",
  "quotes-ui-lib": "static-1.81458",
  "stripe-connect-js": "static-1.74",
  "draft-content-plugins": "static-1.28820",
  "ContentData": "static-1.69127",
  "layout-data-lib": "static-1.10190",
  "ContentComponents": "static-2.72008",
  "marketing-contacts-lib": "static-1.10869",
  "marketing-email-service-types": "static-1.2062",
  "messaging-editing-lib": "static-1.47027",
  "messaging-usage-based-billing-components-lib": "static-1.1889",
  "automation-ui-source-apps": "static-1.19559",
  "automation-ui-types": "static-1.20477",
  "messaging-types-lib": "static-1.46764",
  "onboarding-settings-client": "static-1.4755",
  "sequences-client-types-lib": "static-1.8320",
  "commerce-tax-lib": "static-1.787",
  "price-books-api": "static-1.1628",
  "price-books-components": "static-1.1686",
  "property-description-translator": "static-1.4084",
  "ramp-editor": "static-1.790",
  "commerce-analytics-service-client": "static-1.3767",
  "totals-ui-components": "static-1.24203",
  "SalesContentIndexUI": "static-3.9566",
  "advanced-menus-core": "static-1.15510",
  "advanced-menus-lib": "static-1.12391",
  "ui-memberships-settings-lib": "static-1.34707",
  "automation-ui-ubb": "static-1.6393",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7582",
  "data-token-views": "static-1.16794",
  "forms-utils-lib": "static-1.13017",
  "payments-embed-points-lib": "static-1.13507",
  "simple-menus-core": "static-1.15509",
  "simple-menus-lib": "static-1.17026",
  "videoconference-integration-components": "static-1.7173",
  "marketing-contacts-client": "static-1.7755",
  "mc-hard-limits-client-types": "static-1.148",
  "automation-applications-service-types": "static-1.3647",
  "automation-platform-service-types": "static-1.2658",
  "ContentEditorUI": "static-2.77799",
  "short-messages-app-service-client": "static-1.4165",
  "web-interactives-components": "static-1.14173",
  "web-interactives-data": "static-1.14174",
  "messaging-shared-utils-lib": "static-1.1338",
  "messaging-user-info-utils-lib": "static-1.1508",
  "email-portal-health-service-types": "static-1.1224",
  "line-items-api": "static-1.1034",
  "commerce-totals-service-types": "static-1.3992",
  "FireAlarmUi": "static-1.4681",
  "sales-templates-service-types-lib": "static-1.4344",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22413",
  "automation-ui-usage-tracking": "static-1.21876",
  "data-studio-ubb": "static-1.3407",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27563",
  "content-management-data-lib": "static-1.5869",
  "copilot-plugins": "static-1.11712",
  "cta-picker": "static-1.36990",
  "customer-agent-discovery-components-lib": "static-1.3780",
  "editor-components": "static-1.13575",
  "editor-iframe-lib": "static-1.8731",
  "error-messaging-js": "static-1.5441",
  "FormsCommonComponents": "static-1.86478",
  "pictos": "static-7.189",
  "react-transition-group": "static-2.69",
  "redux-request-state": "static-1.10896",
  "SharedLegalStrings": "static-1.1993",
  "smart-content-core": "static-1.43075",
  "smart-content-lib": "static-1.43728",
  "social-composer-lib": "static-1.60081",
  "structured-content-lib": "static-1.25818",
  "theme-previewer-lib": "static-1.53848",
  "tinymce-copilot": "static-1.17066",
  "xray-recommendation-lib": "static-1.8206",
  "automation-ui-routing": "static-1.21834",
  "sql-reporting-client-types": "static-1.5846",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42697",
  "campaigns-utils-lib": "static-1.3444",
  "reporting-enablement": "static-1.23717",
  "forms-ai-lib": "static-1.4686",
  "codemirror-dlb": "static-1.59358",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6686",
  "report-customization-components": "static-1.13798",
  "data-quality-ui-library": "static-1.13676",
  "reporting-filters": "static-1.908",
  "reporting-insights-lib": "static-1.2459"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13115",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.490",
  "data-fetching-client": "/data-fetching-client/static-1.9903",
  "foundations-components": "/foundations-components/static-1.8382",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1407",
  "foundations-theming": "/foundations-theming/static-1.4701",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.86",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8273",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10524",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11730",
  "I18n": "/I18n/static-7.1661",
  "jasmine-runner": "/jasmine-runner/static-1.6695",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.547",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13178",
  "quartz": "/quartz/static-1.7365",
  "react-dlb": "/react-dlb/static-1.84",
  "react-rhumb": "/react-rhumb/static-1.16954",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3102",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10509",
  "reselect": "/reselect/static-3.9",
  "settings-ui-lib": "/settings-ui-lib/static-1.12766",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7555",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11392",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9779",
  "unified-auth": "/unified-auth/static-1.798",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1080",
  "usage-tracker": "/usage-tracker/static-1.7602",
  "usage-tracker-core": "/usage-tracker-core/static-1.7452",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8345",
  "hub-http": "/hub-http/static-1.6458",
  "integrations-lib": "/integrations-lib/static-1.16923",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20596",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.582",
  "property-management-iframe": "/property-management-iframe/static-1.13985",
  "quartz-config": "/quartz-config/static-1.1143",
  "quartz-core": "/quartz-core/static-1.6584",
  "quartz-routing": "/quartz-routing/static-1.795",
  "quick-fetch": "/quick-fetch/static-1.4092",
  "react": "/react/static-7.190",
  "rpc-client-utils": "/rpc-client-utils/static-1.4909",
  "ts-schema": "/ts-schema/static-1.4254",
  "ui-universal-auth": "/ui-universal-auth/static-1.9284",
  "UIComponents": "/UIComponents/static-3.8676",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3575",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3642",
  "quartz-webpack": "/quartz-webpack/static-1.3589",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.443",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4651",
  "floating-ui": "/floating-ui/static-1.61",
  "foundations-assets": "/foundations-assets/static-1.5122",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2417",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-story-utils": "/hs-story-utils/static-1.9673",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.60",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5515",
  "react-virtualized": "/react-virtualized/static-2.104",
  "StyleGuideUI": "/StyleGuideUI/static-3.495",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2466",
  "ui-fonts": "/ui-fonts/static-1.992",
  "ui-images": "/ui-images/static-2.1229",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3184",
  "foundations-theming-base": "/foundations-theming-base/static-1.3686",
  "stylex": "/stylex/static-1.38",
  "HeadJS": "/HeadJS/static-2.789",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3384",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4564",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8951",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9579",
  "ai-rendering-library": "/ai-rendering-library/static-1.10999",
  "chirp-fetch": "/chirp-fetch/static-1.2137",
  "connections-embed-lib": "/connections-embed-lib/static-1.1429",
  "copilot-toolkit": "/copilot-toolkit/static-1.11740",
  "feedback-loader": "/feedback-loader/static-1.29733",
  "laboratory-lib": "/laboratory-lib/static-3.7398",
  "marketplace-embed": "/marketplace-embed/static-1.22813",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10491",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20551",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14766",
  "sanitize-text": "/sanitize-text/static-1.8396",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6016",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5288",
  "wootric-nps": "/wootric-nps/static-1.7160",
  "quartz-head": "/quartz-head/static-1.1030",
  "web-vitals": "/web-vitals/static-1.11",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4903",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4398",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2651",
  "reporting-data": "/reporting-data/static-1.68576",
  "cssUtils": "/cssUtils/static-1.869",
  "flux-actions": "/flux-actions/static-1.360",
  "HubStyle": "/HubStyle/static-2.12037",
  "PatternValidationJS": "/PatternValidationJS/static-1.3143",
  "react-colorpicker": "/react-colorpicker/static-2.10453",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10612",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7592",
  "icons": "/icons/static-2.674",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19128",
  "storybook-react": "/storybook-react/static-1.37",
  "trellis-story-utils": "/trellis-story-utils/static-1.4756",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5865",
  "quartz-i18n": "/quartz-i18n/static-1.1040",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.349",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1032",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.926",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.16",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.370",
  "slack-ui-library": "/slack-ui-library/static-1.10643",
  "fsm": "/fsm/static-1.3985",
  "customer-data-objects": "/customer-data-objects/static-1.7933",
  "property-translator": "/property-translator/static-1.5640",
  "hs-locale-management": "/hs-locale-management/static-1.255",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8174",
  "hs-promise-utils": "/hs-promise-utils/static-1.5842",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5124",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14338",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5854",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8023",
  "sanitize": "/sanitize/static-1.4722",
  "superstore": "/superstore/static-1.5004",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10509",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8254",
  "hub-http-janus": "/hub-http-janus/static-1.867",
  "hubspotter-http": "/hubspotter-http/static-1.4824",
  "immutable-less": "/immutable-less/static-1.4897",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18003",
  "nav-meta": "/nav-meta/static-1.30348",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18319",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.880",
  "ai-studio-lib": "/ai-studio-lib/static-1.12354",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18867",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.402",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9323",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8272",
  "ui-product-approvals": "/ui-product-approvals/static-1.28985",
  "ui-tool-access": "/ui-tool-access/static-1.10399",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4018",
  "property-management-common": "/property-management-common/static-1.6273",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.565",
  "module-federation": "/module-federation/static-1.30",
  "quartz-auth": "/quartz-auth/static-1.1040",
  "quartz-test": "/quartz-test/static-1.1040",
  "quartz-tracking": "/quartz-tracking/static-1.744",
  "trellis-components": "/trellis-components/static-1.2485",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.319",
  "bender-build-tools": "/bender-build-tools/static-1.3358",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22627",
  "ContentUtils": "/ContentUtils/static-1.69052",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13277",
  "sassPrefix": "/sassPrefix/static-1.161",
  "avatar-components": "/avatar-components/static-1.2743",
  "breeze-engine-core": "/breeze-engine-core/static-1.844",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.608",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40751",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13426",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15341",
  "ExportDialog": "/ExportDialog/static-6.10626",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41907",
  "reporting-snowflake": "/reporting-snowflake/static-1.57194",
  "reporting-ui-components": "/reporting-ui-components/static-2.65847",
  "reporting-visualizations": "/reporting-visualizations/static-1.60652",
  "trial-components-library": "/trial-components-library/static-1.14020",
  "trellis-theming": "/trellis-theming/static-1.1207",
  "ui-addon-teams": "/ui-addon-teams/static-1.21853",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.454",
  "magpie-lib": "/magpie-lib/static-1.5718",
  "navigation-components": "/navigation-components/static-1.18711",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1566",
  "magpie-types": "/magpie-types/static-1.5178",
  "simple-logging-lib": "/simple-logging-lib/static-1.3295",
  "fail-safe": "/fail-safe/static-1.200",
  "app-governance-lib": "/app-governance-lib/static-1.2291",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10746",
  "purchase-motions-components": "/purchase-motions-components/static-1.6281",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10035",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6019",
  "usage-tracker-public": "/usage-tracker-public/static-1.7413",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3948",
  "reference-resolvers": "/reference-resolvers/static-1.8429",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4166",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.583",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3256",
  "final-form": "/final-form/static-1.75",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "simple-data-table": "/simple-data-table/static-1.3434",
  "atom": "/atom/static-1.5329",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "salesImages": "/salesImages/static-1.530",
  "codemirror": "/codemirror/static-5.99",
  "react-codemirror": "/react-codemirror/static-1.10886",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5002",
  "content-assistance-lib": "/content-assistance-lib/static-1.8130",
  "content-media-capture": "/content-media-capture/static-1.5305",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10072",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24360",
  "growth-payments-core": "/growth-payments-core/static-1.26069",
  "knowledge-content-types": "/knowledge-content-types/static-1.8618",
  "payment-link-components": "/payment-link-components/static-1.24075",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20234",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10132",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9328",
  "video-components-external": "/video-components-external/static-1.12053",
  "video-data-lib": "/video-data-lib/static-1.35711",
  "navigation-messaging": "/navigation-messaging/static-1.8038",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58601",
  "react-dnd-compat": "/react-dnd-compat/static-1.4862",
  "batch-promise": "/batch-promise/static-1.1791",
  "crm-component-utils": "/crm-component-utils/static-1.39724",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6136",
  "customer-data-properties": "/customer-data-properties/static-1.52423",
  "external-options-client-types": "/external-options-client-types/static-1.4301",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7140",
  "property-value-citations": "/property-value-citations/static-1.3037",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8346",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10522",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "cms-field-types": "/cms-field-types/static-1.5061",
  "content-icons-ui": "/content-icons-ui/static-1.2310",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.183",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.769",
  "pulse": "/pulse/static-1.873",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7495",
  "crm-message-bus": "/crm-message-bus/static-1.43636",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23186",
  "events-data-lib": "/events-data-lib/static-1.489",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4972",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4181",
  "hs-resources": "/hs-resources/static-1.436",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1243",
  "onboarding-scopes": "/onboarding-scopes/static-1.6704",
  "onboarding-tours": "/onboarding-tours/static-1.17037",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14363",
  "academy-common-lib": "/academy-common-lib/static-1.14801",
  "dashboard-lib": "/dashboard-lib/static-1.82628",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19109",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18859",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8950",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11342",
  "user-context": "/user-context/static-1.5358",
  "reporting-plugins": "/reporting-plugins/static-1.10671",
  "reporting-reports": "/reporting-reports/static-1.68254",
  "hubs-service-types": "/hubs-service-types/static-1.1503",
  "purchase-motions-api": "/purchase-motions-api/static-1.6284",
  "signup-constants": "/signup-constants/static-1.19488",
  "idb-keyval": "/idb-keyval/static-1.48",
  "reactive-lib": "/reactive-lib/static-1.967",
  "nest": "/nest/static-1.483",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.544",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.151",
  "framework-listing-lib": "/framework-listing-lib/static-2.29372",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31316",
  "apps-service-types": "/apps-service-types/static-1.3995",
  "oauth-service-types": "/oauth-service-types/static-1.4501",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8306",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5251",
  "one-click-checkout": "/one-click-checkout/static-1.305",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7847",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15196",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3756",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9986",
  "redux-thunk": "/redux-thunk/static-2.77",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-flip-move": "/react-flip-move/static-1.75",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29210",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13109",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4670",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.610",
  "ui-addon-opt": "/ui-addon-opt/static-4.8609",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6533",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5326",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3779",
  "data-token-picker": "/data-token-picker/static-1.16813",
  "FileManagerLib": "/FileManagerLib/static-1.40000",
  "content-media-compositions": "/content-media-compositions/static-2.17116",
  "media-bridge-lib": "/media-bridge-lib/static-1.19334",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22618",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3398",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7115",
  "card-properties-lib": "/card-properties-lib/static-1.44900",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37677",
  "crm-actions": "/crm-actions/static-1.6598",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44375",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9851",
  "customer-data-tracking": "/customer-data-tracking/static-1.7128",
  "calling-global-api": "/calling-global-api/static-1.65366",
  "calling-internal-common": "/calling-internal-common/static-1.31562",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66748",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59042",
  "commerce-products-lib": "/commerce-products-lib/static-1.10403",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3975",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4473",
  "crm-links": "/crm-links/static-1.6569",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4308",
  "formula-editor": "/formula-editor/static-1.14673",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4386",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.882",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3868",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49528",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4143",
  "smart-property-lib": "/smart-property-lib/static-1.8164",
  "tiered-pricing": "/tiered-pricing/static-1.1856",
  "topics-actions-lib": "/topics-actions-lib/static-1.407",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11232",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.259",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7045",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.376",
  "event-emitter": "/event-emitter/static-1.1200",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1550",
  "growth-data-modal": "/growth-data-modal/static-1.5816",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3307",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2592",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1103",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7890",
  "academy-service-client": "/academy-service-client/static-1.3936",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39859",
  "SafeStorage": "/SafeStorage/static-1.4650",
  "video-embed": "/video-embed/static-1.36545",
  "redux-actions": "/redux-actions/static-3.68",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24912",
  "viral-links-lib": "/viral-links-lib/static-1.7321",
  "nested-table": "/nested-table/static-1.480",
  "timezone-utils": "/timezone-utils/static-2.5494",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18227",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9990",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5572",
  "customer-data-views-management": "/customer-data-views-management/static-1.25929",
  "framework-data-table": "/framework-data-table/static-2.12443",
  "nudge-client-utils": "/nudge-client-utils/static-1.3065",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1417",
  "switchboard-lib": "/switchboard-lib/static-1.461",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1481",
  "app-users-service-client": "/app-users-service-client/static-1.5864",
  "app-users-service-types": "/app-users-service-types/static-1.5272",
  "mini-checkout-client": "/mini-checkout-client/static-1.27400",
  "onboarding-utils": "/onboarding-utils/static-1.5608",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2118",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29195",
  "checkout-sdk": "/checkout-sdk/static-3.24243",
  "payment-method-components": "/payment-method-components/static-1.7095",
  "touchless-buying-components": "/touchless-buying-components/static-1.6111",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3731",
  "edison-service-client-types": "/edison-service-client-types/static-1.637",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6829",
  "audio-components": "/audio-components/static-1.6272",
  "FileManagerImages": "/FileManagerImages/static-1.37511",
  "video-components": "/video-components/static-1.14055",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92724",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46641",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17784",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4508",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1735",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19986",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19126",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10955",
  "crm-fe-perf": "/crm-fe-perf/static-1.23146",
  "calling-error-reporting": "/calling-error-reporting/static-1.31569",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11287",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6785",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1905",
  "commerce-permissions": "/commerce-permissions/static-1.1023",
  "products-iframe-lib": "/products-iframe-lib/static-1.8494",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10906",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6688",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10607",
  "sales-views-client-types": "/sales-views-client-types/static-1.4504",
  "bark-lib": "/bark-lib/static-1.16752",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.573",
  "policy-lib": "/policy-lib/static-1.7040",
  "react-tinymce": "/react-tinymce/static-1.55872",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10670",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54998",
  "tinymce-plugins": "/tinymce-plugins/static-1.58112",
  "tinymce-themes": "/tinymce-themes/static-1.56968",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2397",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2620",
  "user-context-client": "/user-context-client/static-1.4754",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4779",
  "outpost": "/outpost/static-1.4408",
  "draft-convert": "/draft-convert/static-2.77",
  "draft-extend": "/draft-extend/static-3.80",
  "draft-js": "/draft-js/static-5.82",
  "draft-plugins": "/draft-plugins/static-2.22082",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4091",
  "ts-utils-lib": "/ts-utils-lib/static-1.421",
  "crm-export-dialog": "/crm-export-dialog/static-1.6531",
  "crm-view-components": "/crm-view-components/static-1.997",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.67",
  "customer-data-associations": "/customer-data-associations/static-1.7577",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2822",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3141",
  "whisper-core-api": "/whisper-core-api/static-1.7224",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15455",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46744",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.832",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4238",
  "company-details-components": "/company-details-components/static-1.6446",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.801",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15493",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3701",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "crm_universal": "/crm_universal/static-1.22424",
  "customer-data-email": "/customer-data-email/static-1.18449",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37869",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40100",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13140",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55541",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22089",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18686",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72737",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5579",
  "data-agent-utils": "/data-agent-utils/static-1.179",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10111",
  "utility-belt": "/utility-belt/static-1.2777",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23697",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7923",
  "customer-data-rte": "/customer-data-rte/static-1.33556",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6190",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5353",
  "qrcode-generator": "/qrcode-generator/static-1.73",
  "quotes-client-types": "/quotes-client-types/static-1.38827",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36682",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16262",
  "hub-http-contrib": "/hub-http-contrib/static-1.3285",
  "interframe": "/interframe/static-3.5003",
  "tinymce-data": "/tinymce-data/static-1.41083",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5460",
  "layout-dnd-components": "/layout-dnd-components/static-1.12890",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11865",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16216",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9223",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7854",
  "access-control-lib": "/access-control-lib/static-1.10683",
  "EmailComponents": "/EmailComponents/static-1.55449",
  "EmailData": "/EmailData/static-1.54127",
  "redux-less": "/redux-less/static-2.9726",
  "company-details-service-types": "/company-details-service-types/static-1.4186",
  "segments-query-core": "/segments-query-core/static-1.1670",
  "pricing-pages-api": "/pricing-pages-api/static-1.15358",
  "sequences-lib": "/sequences-lib/static-1.8463",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10600",
  "products-ui-components": "/products-ui-components/static-1.40921",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7464",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55557",
  "commerce-products-api": "/commerce-products-api/static-1.2636",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57615",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103415",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81458",
  "stripe-connect-js": "/stripe-connect-js/static-1.74",
  "draft-content-plugins": "/draft-content-plugins/static-1.28820",
  "ContentData": "/ContentData/static-1.69127",
  "layout-data-lib": "/layout-data-lib/static-1.10190",
  "ContentComponents": "/ContentComponents/static-2.72008",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10869",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2062",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47027",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1889",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19559",
  "automation-ui-types": "/automation-ui-types/static-1.20477",
  "messaging-types-lib": "/messaging-types-lib/static-1.46764",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4755",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8320",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.787",
  "price-books-api": "/price-books-api/static-1.1628",
  "price-books-components": "/price-books-components/static-1.1686",
  "property-description-translator": "/property-description-translator/static-1.4084",
  "ramp-editor": "/ramp-editor/static-1.790",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3767",
  "totals-ui-components": "/totals-ui-components/static-1.24203",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9566",
  "advanced-menus-core": "/advanced-menus-core/static-1.15510",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12391",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34707",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6393",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7582",
  "data-token-views": "/data-token-views/static-1.16794",
  "forms-utils-lib": "/forms-utils-lib/static-1.13017",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13507",
  "simple-menus-core": "/simple-menus-core/static-1.15509",
  "simple-menus-lib": "/simple-menus-lib/static-1.17026",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7173",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7755",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.148",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3647",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2658",
  "ContentEditorUI": "/ContentEditorUI/static-2.77799",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4165",
  "web-interactives-components": "/web-interactives-components/static-1.14173",
  "web-interactives-data": "/web-interactives-data/static-1.14174",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1338",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1508",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1224",
  "line-items-api": "/line-items-api/static-1.1034",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3992",
  "FireAlarmUi": "/FireAlarmUi/static-1.4681",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4344",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22413",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21876",
  "data-studio-ubb": "/data-studio-ubb/static-1.3407",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27563",
  "content-management-data-lib": "/content-management-data-lib/static-1.5869",
  "copilot-plugins": "/copilot-plugins/static-1.11712",
  "cta-picker": "/cta-picker/static-1.36990",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3780",
  "editor-components": "/editor-components/static-1.13575",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8731",
  "error-messaging-js": "/error-messaging-js/static-1.5441",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86478",
  "pictos": "/pictos/static-7.189",
  "react-transition-group": "/react-transition-group/static-2.69",
  "redux-request-state": "/redux-request-state/static-1.10896",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1993",
  "smart-content-core": "/smart-content-core/static-1.43075",
  "smart-content-lib": "/smart-content-lib/static-1.43728",
  "social-composer-lib": "/social-composer-lib/static-1.60081",
  "structured-content-lib": "/structured-content-lib/static-1.25818",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53848",
  "tinymce-copilot": "/tinymce-copilot/static-1.17066",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8206",
  "automation-ui-routing": "/automation-ui-routing/static-1.21834",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5846",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42697",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3444",
  "reporting-enablement": "/reporting-enablement/static-1.23717",
  "forms-ai-lib": "/forms-ai-lib/static-1.4686",
  "codemirror-dlb": "/codemirror-dlb/static-1.59358",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6686",
  "report-customization-components": "/report-customization-components/static-1.13798",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13676",
  "reporting-filters": "/reporting-filters/static-1.908",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2459"
}
};
